import { render } from "./UserAccountMenu.vue?vue&type=template&id=194ff6aa"
const script = {}

import exportComponent from "E:\\wamp64\\www\\tusacan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__